export default "__VITE_ASSET__8k9ROXV1__"